import React, { type FunctionComponent } from 'react'
import { type DataVizData } from 'legacy/components/DataViz/dataViz.types'
import ChartContainer from 'legacy/components/DataViz/ChartContainer'
import MetricsContainer from 'legacy/components/DataViz/MetricsContainer'
import { errors } from 'utils/error-handling/errors'

type Props = DataVizData

const DynamicContainer: FunctionComponent<Props> = props => {
  switch (props.type) {
    case 'charts': {
      const { title_key, action_key, charts, time_range, chart_downloadable } = props.data

      return (
        <ChartContainer
          title={title_key}
          action={action_key}
          charts={charts}
          timeRange={time_range}
          downloadable={chart_downloadable}
        />
      )
    }

    case 'metrics': {
      const { title_key, action_key, metrics } = props.data

      return <MetricsContainer title={title_key} action={action_key} metrics={metrics} />
    }

    default: {
      // Should never reach this point
      errors.captureMessage('Invalid DynamicContainer type: ', {
        level: 'error',
        extra: { props },
      })
      return null
    }
  }
}

// Exporting default for legacy compatibility
export default DynamicContainer
